export var BusinessUserRole;
(function (BusinessUserRole) {
    BusinessUserRole["Admin"] = "ADMIN";
    BusinessUserRole["Staff"] = "STAFF";
    BusinessUserRole["Customer"] = "CUSTOMER";
})(BusinessUserRole || (BusinessUserRole = {}));
export var BusinessStaffRole;
(function (BusinessStaffRole) {
    BusinessStaffRole["Developer"] = "DEVELOPER";
    BusinessStaffRole["Finance"] = "FINANCE";
    BusinessStaffRole["Support"] = "SUPPORT";
    BusinessStaffRole["Operations"] = "OPERATIONS";
})(BusinessStaffRole || (BusinessStaffRole = {}));
export var BusinessRoleAction;
(function (BusinessRoleAction) {
    BusinessRoleAction["Create"] = "CREATE";
    BusinessRoleAction["Read"] = "READ";
    BusinessRoleAction["Update"] = "UPDATE";
    BusinessRoleAction["Delete"] = "DELETE";
})(BusinessRoleAction || (BusinessRoleAction = {}));
export var BusinessRoleEntity;
(function (BusinessRoleEntity) {
    BusinessRoleEntity["User"] = "USER";
    BusinessRoleEntity["UserList"] = "USER_LIST";
    BusinessRoleEntity["Business"] = "BUSINESS";
    BusinessRoleEntity["BusinessList"] = "BUSINESS_LIST";
    BusinessRoleEntity["Currency"] = "CURRENCY";
    BusinessRoleEntity["CurrencyList"] = "CURRENCY_LIST";
    BusinessRoleEntity["Transaction"] = "TRANSACTION";
    BusinessRoleEntity["TransactionList"] = "TRANSACTION_LIST";
    BusinessRoleEntity["TransactionReceipt"] = "TRANSACTION_RECEIPT";
    BusinessRoleEntity["APIKey"] = "API_KEY";
})(BusinessRoleEntity || (BusinessRoleEntity = {}));
export var BusinessRolePermission;
(function (BusinessRolePermission) {
    BusinessRolePermission["PaymentMethodRead"] = "PAYMENT_METHOD.READ";
    BusinessRolePermission["PaymentMethodCreate"] = "PAYMENT_METHOD.CREATE";
    BusinessRolePermission["PaymentMethodDelete"] = "PAYMENT_METHOD.DELETE";
    BusinessRolePermission["TransactionHistoryRead"] = "TRANSACTION.HISTORY.READ";
    BusinessRolePermission["TransactionReceiptRead"] = "TRANSACTION.RECEIPT.READ";
    BusinessRolePermission["TransactionQuoteRead"] = "TRANSACTION.QUOTE.READ";
    BusinessRolePermission["TransactionDepositCreate"] = "TRANSACTION.DEPOSIT.CREATE";
    BusinessRolePermission["TransactionWithdrawCreate"] = "TRANSACTION.WITHDRAW.CREATE";
    BusinessRolePermission["TransactionSwapCreate"] = "TRANSACTION.SWAP.CREATE";
    BusinessRolePermission["WalletBalancesRead"] = "WALLET.BALANCES.READ";
    BusinessRolePermission["RatesRead"] = "RATES.READ";
    BusinessRolePermission["SettingsBusinessProfileRead"] = "SETTINGS.BUSINESS_PROFILE.READ";
    BusinessRolePermission["SettingsTeamListRead"] = "SETTINGS.TEAM_LIST.READ";
    BusinessRolePermission["SettingsTeamMemberInvite"] = "SETTINGS.TEAM_MEMBER.INVITE";
    BusinessRolePermission["DeveloperApiKeyCreate"] = "DEVELOPER.API_KEY.CREATE";
    BusinessRolePermission["DeveloperApiKeyRead"] = "DEVELOPER.API_KEY.READ";
    BusinessRolePermission["DeveloperApiKeyDelete"] = "DEVELOPER.API_KEY.DELETE";
    BusinessRolePermission["DeveloperWebhookUrlUpdate"] = "DEVELOPER.WEBHOOK_URL.UPDATE";
    BusinessRolePermission["DeveloperWebhookUrlRead"] = "DEVELOPER.WEBHOOK_URL.READ";
    BusinessRolePermission["DeveloperIPWhitelistRead"] = "DEVELOPER.IP_WHITELIST.READ";
    BusinessRolePermission["DeveloperIPWhitelistUpdate"] = "DEVELOPER.IP_WHITELIST.UPDATE";
    BusinessRolePermission["AdminExclusive"] = "ADMIN.EXCLUSIVE";
    BusinessRolePermission["PaymentLinqRead"] = "PAYMENT_LINQ.READ";
    BusinessRolePermission["PaymentLinqCreate"] = "PAYMENT_LINQ.CREATE";
    BusinessRolePermission["PaymentLinqUpdate"] = "PAYMENT_LINQ.UPDATE";
    BusinessRolePermission["PaymentLinqDelete"] = "PAYMENT_LINQ.DELETE";
    BusinessRolePermission["CheckoutLinkCreate"] = "CHECKOUT_LINK.CREATE";
    BusinessRolePermission["CustomerRead"] = "CUSTOMER.READ";
    BusinessRolePermission["CustomerCreate"] = "CUSTOMER.CREATE";
    BusinessRolePermission["CustomerUpdate"] = "CUSTOMER.UPDATE";
    BusinessRolePermission["CustomerDelete"] = "CUSTOMER.DELETE";
    BusinessRolePermission["ComplianceKybSubmit"] = "COMPLIANCE.KYB.SUBMIT";
    BusinessRolePermission["ComplianceKybRead"] = "COMPLIANCE.KYB.READ";
    BusinessRolePermission["PaymentBatchRead"] = "PAYMENT_BATCH.READ";
    BusinessRolePermission["PaymentBatchCreate"] = "PAYMENT_BATCH.CREATE";
    BusinessRolePermission["PaymentBatchUpdate"] = "PAYMENT_BATCH.UPDATE";
    BusinessRolePermission["PaymentBatchDelete"] = "PAYMENT_BATCH.DELETE";
    BusinessRolePermission["VirtualCardRead"] = "VIRTUAL_CARD.READ";
    BusinessRolePermission["VirtualCardCreate"] = "VIRTUAL_CARD.CREATE";
    BusinessRolePermission["VirtualCardUpdate"] = "VIRTUAL_CARD.UPDATE";
    BusinessRolePermission["VirtualCardFund"] = "VIRTUAL_CARD.FUND";
    BusinessRolePermission["VirtualCardDelete"] = "VIRTUAL_CARD.DELETE";
    BusinessRolePermission["MediaUpload"] = "MEDIA.UPLOAD";
})(BusinessRolePermission || (BusinessRolePermission = {}));
//# sourceMappingURL=BusinessUserRole.js.map